import regeneratorRuntime from "/app/node_modules/.pnpm/regenerator-runtime@0.13.4/node_modules/regenerator-runtime/runtime.js";
import { NAMESPACE } from 'portal-common/constants/requestConstants';
import logger from 'portal-common/helpers/logger';
import { api } from 'portal-common/http';
import { GET_USER_INFO_URL } from '../common/constants';
import { getUserRemoteIP } from '../common/util';
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var getRealQcloudFromByCookie = function(request) {
    var ref;
    var qcloudFrom = (request === null || request === void 0 ? void 0 : (ref = request.cookies) === null || ref === void 0 ? void 0 : ref.qcloud_from) || '';
    var realQcloudFrom = '';
    if (qcloudFrom) {
        var ref1;
        ref1 = _slicedToArray(String(qcloudFrom).split('-'), 1), qcloudFrom = ref1[0], ref1;
        if (/^[0-9a-zA-Z.]{1,100}$/.test(qcloudFrom)) {
            realQcloudFrom = qcloudFrom;
        }
    }
    return realQcloudFrom;
};
// 获取用户信息，带校验登录态作用
export var getUserInfo = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req) {
    var ref, ref2, ref3, ref4, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                ;
                _ctx.next = 3;
                return api.call(GET_USER_INFO_URL, {
                    method: 'get',
                    params: {
                        uin: (req === null || req === void 0 ? void 0 : (ref = req.cookies) === null || ref === void 0 ? void 0 : ref.uin) || '',
                        skey: (req === null || req === void 0 ? void 0 : (ref2 = req.cookies) === null || ref2 === void 0 ? void 0 : ref2.skey) || ''
                    },
                    headerconfig: {
                        Cookie: "uin=".concat((req === null || req === void 0 ? void 0 : (ref3 = req.cookies) === null || ref3 === void 0 ? void 0 : ref3.uin) || '', ";skey=").concat((req === null || req === void 0 ? void 0 : (ref4 = req.cookies) === null || ref4 === void 0 ? void 0 : ref4.skey) || '')
                    }
                });
            case 3:
                result = _ctx.sent;
                return _ctx.abrupt("return", result);
            case 5:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
/** *
*@description 根据活动资源查询商品信息
*@param "ecReqList":[{
"eventId":"E2008102031",
"ecId":"EC200123990001"
},{
"eventId":"E2008102031",
"ecId":"EC20012398002"
}],
 * */ export var queryEventCommodityList = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
    var API_PREFIX, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "/".concat(NAMESPACE.QCINTL_API);
                _ctx.next = 3;
                return api.fetchMidProxy("".concat(API_PREFIX, "/portal-operation-event/queryEventCommodityList"), {
                    body: params,
                    method: 'post'
                });
            case 3:
                result = _ctx.sent;
                return _ctx.abrupt("return", result);
            case 5:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
/** *
 *@description 下单
 *@param uin
 *@param orderInfo
 * */ export var createEventOrder = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req) {
    var API_PREFIX, WOA_API_PREFIX, ref, code, _data, data, _uin, uin, tmp, owenUin, ref5, billParams, bill, _data1, isOpen, account, data1, ip, params, referer, originate, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "/".concat(NAMESPACE.QCINTL_API);
                WOA_API_PREFIX = "/".concat(NAMESPACE.QCINTL_WOA_API);
                _ctx.next = 4;
                return getUserInfo(req);
            case 4:
                ref = _ctx.sent;
                code = ref.code;
                _data = ref.data;
                data = _data === void 0 ? {
                } : _data;
                _uin = data.uin, uin = _uin === void 0 ? '' : _uin, tmp = data.owner_uin, owenUin = tmp === void 0 ? '' : tmp;
                if (!(code === 0 && owenUin)) {
                    _ctx.next = 43;
                    break;
                }
                ;
                billParams = req.body;
                billParams.uin = owenUin;
                _ctx.next = 15;
                return api.fetchMidProxy("".concat(WOA_API_PREFIX, "/backend-account-billing/v1/GetBillAccountIsOpenByUin"), {
                    body: billParams,
                    method: 'post'
                });
            case 15:
                bill = _ctx.sent;
                logger.info('discountApi-GetBillAccountIsOpenByUin', {
                    billParams: billParams,
                    billresult: bill
                });
                _data1 = bill.data, isOpen = _data1.is_open;
                if (isOpen) {
                    _ctx.next = 27;
                    break;
                }
                billParams.page = 1;
                billParams.page_size = 10;
                _ctx.next = 23;
                return api.fetchMidProxy("".concat(WOA_API_PREFIX, "/backend-account-billing/v1/GetBillAccountPaymentMethod"), {
                    body: billParams,
                    method: 'post'
                });
            case 23:
                account = _ctx.sent;
                logger.info('discountApi-GetBillAccountPaymentMethod', {
                    billParams: billParams,
                    paymentMethod: account
                });
                data1 = account.data;
                return _ctx.abrupt("return", {
                    code: -1001,
                    data: data1,
                    msg: '获取绑卡信息'
                });
            case 27:
                ip = getUserRemoteIP(req);
                params = req.body;
                params.uin = uin;
                params.ownerUin = "".concat(owenUin);
                params.skey = (req === null || req === void 0 ? void 0 : (ref5 = req.cookies) === null || ref5 === void 0 ? void 0 : ref5.skey) || '';
                params.system = {
                    ip: ip
                };
                referer = req.headers.referer || '';
                originate = getRealQcloudFromByCookie(req);
                params.additionNoSign = {
                    originate: originate,
                    extparam: {
                        referer: referer
                    }
                };
                _ctx.next = 38;
                return api.fetchMidProxy("".concat(API_PREFIX, "/portal-operation-event/createEventOrder"), {
                    body: params,
                    method: 'post'
                });
            case 38:
                result = _ctx.sent;
                logger.info('discountApi-createEventOrder', {
                    params: params,
                    result: result
                });
                if (Object.prototype.hasOwnProperty.call(result, 'headers')) {
                    delete result.headers;
                }
                if (Object.prototype.hasOwnProperty.call(data, 'config')) {
                    delete result.config;
                }
                return _ctx.abrupt("return", result);
            case 43:
                if (Object.prototype.hasOwnProperty.call(data, 'config')) {
                    delete data.config;
                }
                return _ctx.abrupt("return", {
                    code: -1000,
                    data: data,
                    msg: '获取用户信息出错'
                });
            case 45:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
export var queryEventCommodityPrice = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
    var API_PREFIX, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "/".concat(NAMESPACE.QCINTL_API);
                _ctx.next = 3;
                return api.fetchMidProxy("".concat(API_PREFIX, "/portal-operation-event/queryEventCommodityPrice"), {
                    body: params,
                    method: 'post'
                });
            case 3:
                result = _ctx.sent;
                return _ctx.abrupt("return", result.data);
            case 5:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
export var queryBluePrints = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
    var API_PREFIX, result, code, data;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "/".concat(NAMESPACE.QCINTL_API);
                _ctx.next = 3;
                return api.fetchMidProxy("".concat(API_PREFIX, "/portal-operation-event/queryBluePrints"), {
                    body: params,
                    method: 'post'
                });
            case 3:
                result = _ctx.sent;
                code = result.code, data = result.data;
                if (!(code === 0)) {
                    _ctx.next = 7;
                    break;
                }
                return _ctx.abrupt("return", result);
            case 7:
                return _ctx.abrupt("return", data);
            case 8:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
